<template>
  <FloorPlannerIframe
    :art_nr="route.query.art_nr"
    :art_name="route.query.art_name"
    :design="route.query.design"
    :surface="route.query.surface"
    :construction="route.query.construction"
  />
</template>

<script setup lang="ts">
const { $t } = useNuxtApp();
const route = useRoute();
useHead({
  title: $t('floorPlanner.headline2'),
});
</script>

<style scoped lang="postcss">
</style>
